import { ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteConstants } from 'src/app/core/constants/RouteConstants';
import { UserService } from 'src/app/core/services/api-services/user.service';
import { PatientDashboardService } from 'src/app/patient-dashboard/patient-dashboard.service';
import { MatTableDataSource } from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { FormControl, FormGroup } from '@angular/forms';
import { KRollService } from 'src/app/core/services/api-services/kroll.service';
import { NEVER } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/core/services/helper.service';
import { AddUserPromoComponent } from 'src/app/patient-dashboard/user-promo-list/add-user-promo/add-user-promo.component';

@Component({
  selector: 'app-user-promo',
  templateUrl: './user-promo.component.html',
  styleUrls: ['./user-promo.component.scss']
})
export class UserPromoComponent implements OnInit {

  tenant: any = localStorage.getItem('tenant')
  injector: any;
  selected: any;
  progress_spinner: boolean = false;
  paginationObj: any = {
    "page":0,
    "per_page":8,
    "search": '',
    "searchBy": '',
    'totalItems' : 0,
    'user_id' : 0,
    'promoId': 0
  }
  surveyList: any = []

  config = {
    id: 'server',
    itemsPerPage: 10,
    currentPage: 0,
    totalItems: 0
  };

  searchForm: FormGroup = new FormGroup({});
  isLoading: boolean = false
  medical_conditions: any = []

  displayedColumns: string[] = ['PromoCode','ExpireDate', 'Discount', 'MaxValue', 'Limitation', 'Mode', 'RemainingBalance', 'CreatedBy'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  selection = new SelectionModel<PeriodicElement>(true, []);

  constructor( public userService: UserService,
    public RouteConstants: RouteConstants,
    public toastr: ToastrService,
    public dialog: MatDialog,
    private router: Router,
    public patientService: PatientDashboardService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    public helperService: HelperService,
    public dialogRef: MatDialogRef<UserPromoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
    ) { 
  }

  ngOnInit(): void {
    if(this.route.snapshot.params['id']){
    this.paginationObj.user_id = this.route.snapshot.params['id'];
    }
    if(this.props){
      this.paginationObj.user_id = this.props.user_id
    }
    this.getPromoCodeList();
    this.searchFormInitialize();
  }
  ngAfterViewInit(): void {
    this.searchFormInitialize();
    this.searchFormEvent();
    this.cdRef.detectChanges();
  }

  getPromoCodeList(){
    if(this.tenant == 'wylo') this.paginationObj.type = 'sales_order'
    this.progress_spinner = true
    this.userService.getUserPromoCodeList(this.paginationObj).subscribe((res: any)=>{
      console.log(res);
      
      if(res.body.code == 200){
        this.progress_spinner = false
        res?.body?.data?.map((item:any)=>{
          if(item.id == this.props.promoId){
            item.active = 1
          }else{
            item.active = 0
          }
        })
        this.dataSource.data = res.body.data
      }else{
        this.toastr.error(res?.body?.message)
        this.dialogRef.close(false);
      }
    },
    err => {
      this.progress_spinner = false
    }
    )
  }
  radioChange(event: any, item: any){
    this.updateFeatureFlag(event, item)
  }
  updateFeatureFlag(event: any, item: any){
    let payload = {
      "feature_id":item.id,
      "toggle":event.checked
    }
    this.userService.updateFeatureFlag(payload).subscribe((res: any )=>{
      if(res.body.success){
        this.getPromoCodeList();
        this.toastr.success(res.body.message);
      }
    })
  }

  // new

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  logSelection() {
    this.selection.selected.forEach(s => console.log(s.name));
  }

  pageChange(currentPage: any) {
    this.paginationObj.page = currentPage.pageIndex;
    this.getPromoCodeList()
  }

  resetForm() {
    this.searchForm.reset();
    this.paginationObj.page = this.config.currentPage = 1;
    this.paginationObj.start_date = "";
    this.paginationObj.end_date = "";
    this.paginationObj.search = "";
  }

  searchFormInitialize() {
    this.searchForm = new FormGroup({
      search: new FormControl(this.paginationObj.search),
    })
  }

  navigateToUpdatePromoCode(event:any){
    this.router.navigate(['/portal/appointment/detail/'+event.submission_id]);
  }

  navigateToCreatePromoCode(){
    this.router.navigate(['/portal/promo-code/detail']);
  }


  searchFormEvent() {
    this.searchForm.valueChanges.pipe(
      debounceTime(500), distinctUntilChanged(),
      switchMap((formObj: any) => {
        this.paginationObj.search = formObj.search
        this.getPromoCodeList()
        return NEVER
      })).subscribe(console.log);
  }

  filterByCondition(event: any){
    this.paginationObj.searchBy = 'condition'
    this.paginationObj.search = event.value
    this.getPromoCodeList()
  }

  editPromoCode(item:any){
    this.router.navigate(['/portal/promo-code/detail/'+item.id]);
  }

  removeAndActivePromoCodeFromOrder(item:any){
    let payload :any = {}
    payload.order_id = this.props.id
    payload.promo_code_id = item.promo_code_id
    payload.action = item.active == 1 ? 0 : 1
    this.userService.deleteSaleOrderPromoCode(payload).subscribe((res:any)=>{
      if(res.body.success){
        this.toastr.success(res.body.message[0])
        this.dialogRef.close(true)
      }else{
        this.toastr.error(res.body.message)
        this.dialogRef.close(false)
      }
    },
    err => {
      this.dialogRef.close(false)
    }
    )
  }

  updateStatus(item:any){
    let payload :any = {}
    payload.id = item.id
    payload.is_active = item.is_valid == 1 ? 0 : 1
    this.userService.updatePromoStatus(payload).subscribe((res:any)=>{
      if(res.body.success){
        this.toastr.success(res.body.message)
        this.getPromoCodeList()
      }else{
        this.toastr.error(res.body.message)
      }
    })
  }
  
  addUserPromoCode() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = this.paginationObj.user_id;
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(AddUserPromoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.getPromoCodeList()
      }
    })

  }

}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];

export type PaginationSurveyList = {
  page: number;
  per_page: number;
  sort_type: 'asc' | 'desc' | '';
  sort_key: string;
  search?: string;
  user_id?: string;
  create_pagination?: 1 | 0;
  key?: string;
  autorefillsearch?: string;
  statusFiltersearch?: any;
  server_location?: number;
  type?: string;
};
